export enum ClientContactRole {
    Unknown = 0,
    SystemOwner = 1,
    SecurityPoint = 2,
    SecurityOfficer = 4,
}